"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { emitGTMEvent } from "./utilities";
interface DatalayerTrialProps {
  productName: string;
  trialDuration?: number;
}
export const DatalayerTrial = t0 => {
  const $ = _c(4);
  const {
    productName,
    trialDuration
  } = t0;
  let t1;
  let t2;
  if ($[0] !== productName || $[1] !== trialDuration) {
    t1 = () => {
      emitGTMEvent({
        event: "view_trial_start",
        trial_step: "step_1",
        product_name: productName || "",
        trial_duration_days: trialDuration || null,
        trial_stage: "entry",
        product_trials: {
          step: 1,
          event: "view_trial_start",
          trial_status: "not_started",
          product: productName || ""
        }
      });
    };
    t2 = [productName, trialDuration];
    $[0] = productName;
    $[1] = trialDuration;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
};
export function triggerTrialStarted(productName: string, trialDuration?: number, trialStatus?: string) {
  emitGTMEvent({
    event: "trial_started",
    trial_step: "2",
    product_name: productName,
    trial_days_remaining: trialDuration || null,
    trial_status: "active",
    trial_stage: "confirmed",
    product_trials: {
      step: 2,
      event: "trial_started",
      trial_days_remaining: trialDuration || null,
      product: productName || "",
      trial_status: trialStatus || ""
    }
  });
}
export default DatalayerTrial;